import { render, staticRenderFns } from "./accordionItem.vue?vue&type=template&id=2e32d168&scoped=true"
import script from "./accordionItem.vue?vue&type=script&lang=js"
export * from "./accordionItem.vue?vue&type=script&lang=js"
import style0 from "./accordionItem.vue?vue&type=style&index=0&id=2e32d168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e32d168",
  null
  
)

export default component.exports